import { useLocalStorage } from "@services/common/hooks/useLocalStorage";
import { useAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";

const HISTORY_STORAGE_KEY = "SearchHistory";
const HISTORY_SIZE = 10;
export const useSearchHistory = (): [string[], (newEntry: string) => void] => {
  const [user] = useAuthenticatedUser();
  const [history, setHistory] = useLocalStorage<string[]>(
    `${HISTORY_STORAGE_KEY}-${user?.id}`
  );

  const addToHistory = (newEntry: string) =>
    setHistory([newEntry, ...(history ?? [])].slice(0, HISTORY_SIZE));

  return [history ?? [], addToHistory];
};
